import React from 'react';

import { useHistory } from "react-router-dom";

import { Card, CardActionArea, CardContent, Box, Typography, Grid } from "@material-ui/core"

export default ({
    videos
}) => {
    const history = useHistory();

    return (
        <Grid container>
            {
                videos.map(({ name, description, route }) => (
                    <Grid key={`video-list-item-${name}`} item xs={6} sm={4}>
                        <Card>
                            <CardActionArea onClick={() => history.push(route)}>
                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="h2">
                                        {name}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" component="p">
                                        {description}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))
            }
        </Grid>
    )
}